import React from 'react'
import { useTranslation } from 'react-i18next'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { useHistory } from 'react-router'
import Button from 'design-system/button'
import { ButtonVariant, ButtonSizes } from 'design-system/button/src/Button'
import styles from './CreateButton.module.scss'

const CreateButton: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  return (
    <Button
      variant={ButtonVariant.Primary}
      className={styles.button}
      size={ButtonSizes.Small}
      onClick={() => history.push('/administration/courses/new')}
    >
      <FontAwesomeIcon icon={faPlus} className={styles.setFont} />
      <span className={styles.setFont}>
        {t('administration.courses.list.create.button')}
      </span>
    </Button>
  )
}

export default CreateButton
